import { Amount } from '@/types/amount';
import { CurrencyCodeType, PaymentRailType } from '@/types/currency';
import { ConversionDetails, ExpectedSettlementTimeDetails, FeeDetails } from '@/types/transaction';

export enum FxLockType {
  DEFAULT = 'DEFAULT',
  FX_LOCK_5 = 'FX_LOCK_5',
  FX_LOCK_24 = 'FX_LOCK_24',
  FX_LOCK_48 = 'FX_LOCK_48',
  FX_LOCK_72 = 'FX_LOCK_72',
}

// TODO: move to a separate file
export enum CryptoCurrencyCodeType {
  USDC = 'USDC',
  USDT = 'USDT',
  USD = 'USD',
}

export enum SimulationType {
  FIAT = 'FIAT',
  CRYPTO = 'CRYPTO',
  NONE = '',
}

export interface NfTransactionDetailsResponse {
  readonly conversionDetails: ConversionDetails | null;
  readonly feeDetails: FeeDetails;
  readonly expectedSettlementTimeDetails: ExpectedSettlementTimeDetails | null;
}

export interface CustomFees {
  readonly INTEGRATOR_SPREAD: number;
}

export interface RecreateSimulationRequest {
  readonly simulationId: string;
  readonly customFees: CustomFees;
}

export interface SimulationRequest {
  readonly beneficiaryId: string;
  readonly from: Amount | null;
  readonly toCurrencyCode: CurrencyCodeType;
  readonly to: Amount | null;
  readonly destination?: string;
  readonly type: SimulationType;
  readonly dashboardExperience: true;
  readonly fundingMethod: PaymentRailType | null;
  readonly paymentRail?: PaymentRailType;
  readonly payorId?: string;
  readonly customFees?: CustomFees;
  readonly targetBeneficiaryId?: string;
}

export interface SimulationResponse {
  readonly id: string;
  readonly integratorId: string;
  readonly beneficiaryId: string;
  readonly from: Amount;
  readonly to: Amount;
  readonly flowOfFundsId: string;
  readonly transactionDetails: NfTransactionDetailsResponse;
  readonly executed: boolean;
  readonly guaranteedRate?: boolean;
  readonly rateValidityInMinutes?: number;
  readonly createdDate: string;
  readonly lastModifiedDate: string;
  readonly expiresAt: string;
  readonly fxLockType?: FxLockType;
  readonly fxLockSpreadPercentage?: number;
}
